import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

export const ProductContext = createContext();

export const ProductProvider = ({ children }) => {
  const [products, setProducts] = useState([]);
  const [fetched, setFetched] = useState(false); // Flag to check if products have been fetched

  useEffect(() => {
    const fetchProducts = async () => {
      if (!fetched) {
        try {
          const response = await axios.get('https://earnistamart.online/getproducts');
          const productsData = response.data.products;
          setProducts(productsData);
          setFetched(true); // Set the flag to true after fetching
        } catch (error) {
          console.error("There was an error fetching the products!", error);
        }
      }
    };

    fetchProducts(); // Fetch products only if they haven't been fetched
  }, [fetched]);

  return (
    <ProductContext.Provider value={{ products, setProducts }}>
      {children}
    </ProductContext.Provider>
  );
};
